<!--Header-->
<div class="bg-black fixed-top">
	<div class="container p-lg-0">
		<nav class="navbar navbar-black text-white p-lg-0">
			<a class="navbar-brand brand-bert" [routerLink]="'/'">BERTAZZONI</a>
			<div class="d-flex align-items-center">
				<a class="nav-link text-white" (click)="open(3, $event)"><span>Products</span></a>
				<a class="nav-link text-white" (click)="open(2, $event)"><span>Series</span></a>
				<button class="btn btn-link text-white px-3 d-none d-md-block" type="button" (click)="open(1, $event)">
					<span class="icon-user font-16 mr-3"></span>
					<span>{{utente.username}}</span>
				</button>
				<button class="btn btn-link text-white px-3 position-relative" type="button" [routerLink]="['/cart']">
					<span *ngIf="carrello != 0" class="font-16 bubble-carrello">{{carrello}}</span>
					<span class="icon-supermarket font-16"></span>
				</button>
				<button class="navbar-toggler border-0 pl-3" type="button" (click)="open(0, $event)">
					<span class="icon-open-menu font-16 text-white"></span>
				</button>
			</div>
		</nav>
	</div>
</div>
<div *ngIf="menuOpen" class="position-fixed collapse-width w-100" [style.right]="menuOpen.offset">
	<div class="container p-0">
		<ul class="navbar-nav bg-black text-white text-right col-lg-3 p-0 ml-auto" #tendina>
			<li class="nav-item px-4 py-2 border-bottom border-light d-md-none" *ngFor="let voce of menuOpen.voci">
				<a *ngIf="!voce.hidden" [routerLink]="voce.url" [queryParams]="{q: voce.id}" class="nav-link text-white">
					<span>{{voce.nome | translate | titlecase}}</span>
				</a>
			</li>
			<li class="nav-item px-4 py-2 border-bottom border-light" *ngFor="let voce of menuOpen.voci">
				<a *ngIf="!voce.hidden" [routerLink]="voce.url" [queryParams]="{q: voce.id}" class="nav-link text-white">
					<span>{{voce.nome | translate | titlecase}}</span>
				</a>
			</li>
		</ul>
	</div>
</div>
